import React from 'react';
import styled from 'styled-components';
import { StyledButton } from '../../../Components/Generics.styled';
import TeachPng from '../../../Assets/teach.png';
import Shop1 from '../../../Assets/shop01a.jpg';
import Shop2 from '../../../Assets/shop02.jpg';
import HandBrain from '../../../Assets/ai-hand-brain-354.jpg';
import { useHistory } from 'react-router-dom';

const IntroContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
`;

const TitleContainer = styled.div`
    align-items: center;
    margin-top: 100px;
    display: flex;
    flex-direction: column;
`;

const TitleOne = styled.div`
    display: flex;
    font-size: 56px;
    font-weight: 400;
    color: #2e69fe;
`;

const TitleTwo = styled.div`
    margin-top: 10px;
    display: flex;
    font-size: 36px;
    font-weight: 400px;
`;

const ContentContainer = styled.div`
    margin-top: 50px;
    display: flex;
    flex-direction: row;
    /* width: 100%;
    max-width: 1200px; */

    @media only screen and (max-width: 900px) {
        flex-direction: column;
    }
`;

const Column1 = styled.div`
    display: flex;
    flex-direction: column;
`;

const Column2 = styled.div`
    display: flex;
    flex-direction: column;
`;

const LeftBox = styled.div`
    display: flex;
    padding: 50px;
    flex-direction: column;
    align-items: center;
    background-color: #2e69fe;
    width: 100%;
    max-width: 590px;
    height: 100%;
    border-top-left-radius: 40px 40px;
    border-bottom-left-radius: 40px 40px;
    max-height: 650px;
    min-height: 600px;
`;

const RightBox = styled.div`
    display: flex;
    padding: 50px;
    flex-direction: column;
    align-items: center;
    background-color: #f25c4c;
    width: 100%;
    max-width: 590px;
    height: 100%;
    max-height: 600px;

    border-top-right-radius: 40px 40px;
    border-bottom-right-radius: 40px 40px;
`;

const ImageContainerFlex = styled.div`
    height: 100%;
    width: 100%;
    max-width: 590px;

    align-items: flex-end;
    display: flex;
    min-height: 600px;
    max-height: 600px;

    @media only screen and (max-width: 900px) {
        display: none;
    }
`;

const ImageContainer = styled.div`
    height: 100%;
    width: 100%;
    max-width: 590px;
    display: flex;
    justify-content: center;
    max-height: 600px;
    min-height: 600px;

    @media only screen and (max-width: 900px) {
        display: none;
    }
`;

const Image = styled.img`
    object-fit: cover;
    width: 100%;
`;

const BoxHeader = styled.div`
    color: white;
    font-size: 32px;
    width: 100%;
    max-width: 550px;
    text-align: center;
    margin-top: 40px;
    margin-bottom: 20px;
    line-height: 1.2em;
    font-weight: 600;
`;

const BoxBody = styled.div`
    width: 100%;
    max-width: 650px;
    color: white;
    font-size: 19px;
    line-height: 1.6em;
    font-weight: 400;
`;

const GetStartedContainer = styled.div`
    display: flex;
    height: 100%;
    margin-top: 80px;
    color: #2e69fe;
    font-weight: 500;
    justify-content: space-evenly;

    @media only screen and (max-width: 900px) {
        text-align: center;
        flex-direction: column;
        align-items: center;
    }
`;

const LeftBtn = styled(StyledButton)`
    background-color: white;
    color: black;

    :hover {
        color: white;
    }
`;

const AdvertiserMeetDavie = () => {
    const history = useHistory();

    const routeToTeach = () => {
        history.push('/portal/teach/learn');
    };
    return (
        <IntroContainer>
            <TitleContainer>
                <TitleOne>Meet davie.ai</TitleOne>
                <TitleTwo>
                    YOUR <i style={{ marginLeft: '10px', marginRight: '10px' }}>smart</i>
                    <span style={{ color: '#2e69fe', fontWeight: 'bold' }}>ad</span>-
                    <span style={{ fontWeight: 'bold' }}>visor</span>
                </TitleTwo>
            </TitleContainer>
            <ContentContainer>
                <Column1>
                    <LeftBox>
                        <BoxHeader>
                            If you tell davie about your business, he&apos;ll help you market like a
                            giant.
                        </BoxHeader>

                        <BoxBody>
                            <div style={{ marginBottom: '20px' }}>
                                <span style={{ fontWeight: '500' }}>davie.ai</span> is
                                artifical-intelligence-enabled software platform that YOU train to
                                learn about your business, its products and services and best
                                customers.
                            </div>
                            <div style={{ marginBottom: '20px' }}>
                                With <span style={{ fontWeight: '500' }}>davie.ai</span> on your
                                side, you have help to generate campaigns that will save you time
                                and be effective. You will always be one click away from all the
                                help you need.
                            </div>
                            <div
                                style={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                }}
                            >
                                <LeftBtn onClick={() => routeToTeach()}>Get started now!</LeftBtn>
                            </div>
                        </BoxBody>
                    </LeftBox>
                    <ImageContainer>
                        <Image
                            style={{ maxWidth: '500px', objectFit: 'contain', padding: '12px' }}
                            src={HandBrain}
                        />
                    </ImageContainer>
                    <LeftBox style={{ minHeight: '500px' }}>
                        <BoxHeader>
                            If you tell davie about your business, he&apos;ll help you market like a
                            giant.
                        </BoxHeader>

                        <BoxBody>
                            <div style={{ marginBottom: '20px', marginTop: '25px' }}>
                                When you tell davie about your business, he will create a strategy,
                                design campaigns, find any information that will help market that
                                business and he will suggest the strategy, kinds of ads and media
                                you should use to promote your products and services.
                            </div>
                        </BoxBody>
                    </LeftBox>
                    <ImageContainer>
                        <Image src={Shop2} />
                    </ImageContainer>
                </Column1>
                <Column2>
                    <ImageContainerFlex>
                        <Image src={TeachPng} />
                    </ImageContainerFlex>
                    <RightBox>
                        <BoxHeader style={{ fontSize: '55px' }}>How?</BoxHeader>
                        <BoxBody>
                            <div style={{ marginBottom: '20px' }}>
                                Artificial Intelligence (&quot;AI&quot;) with davie is designed to
                                give you a competitive advantage, save money, get new customers, and
                                generate revenue and profits. davie is a very fast learner and he
                                will soon show you how to use digital marketing tools to efficiently
                                sell.
                            </div>
                            <div style={{ marginBottom: '20px' }}>
                                For those new to AI, artificial intelligence is software and
                                processes used by computers to learn by being trained to use data to
                                perform tasks very quickly as they are taught by programmers. It
                                combines the information it has been given to provide the best
                                answers to a question.
                            </div>
                        </BoxBody>
                    </RightBox>
                    <ImageContainer style={{ minHeight: '500px', maxHeight: '500px' }}>
                        <Image src={Shop1} />
                    </ImageContainer>
                    <RightBox>
                        <BoxHeader style={{ fontSize: '55px' }}>What next?</BoxHeader>
                        <BoxBody>
                            <div style={{ marginBottom: '20px' }}>
                                The first step is answering a few questions, pointing davie to your
                                website and social media postings, if you have them, and he will
                                combine that information with other things he&apos;s learned about
                                your industry, the behavior of your best prospects and customers.
                            </div>
                            <div style={{ marginBottom: '20px' }}>
                                <span style={{ fontWeight: '500' }}>davie.ai</span> has some human
                                assistants too. Our customer success team helps you train davie and
                                they are always available to answer your questions and to help davie
                                guide you through the process of creating the best marketing for
                                your business.
                            </div>
                        </BoxBody>
                    </RightBox>
                </Column2>
            </ContentContainer>
            <GetStartedContainer>
                <div style={{ fontSize: '30px' }}>
                    Lets get started with teaching davie.ai some basics about your business
                </div>
                <StyledButton onClick={() => routeToTeach()}>Get Started Now!</StyledButton>
            </GetStartedContainer>
        </IntroContainer>
    );
};

export default AdvertiserMeetDavie;
